var map = {
	"./adds.svg": "0b94",
	"./basket.svg": "93dc",
	"./car-dealer.svg": "7298",
	"./completed-complaints.svg": "e801",
	"./completed-requests.svg": "c30e",
	"./filter.svg": "b05f",
	"./flies.svg": "2263",
	"./graphs.svg": "85c4",
	"./labels.svg": "3fb2",
	"./logo-text_argo.svg": "0418",
	"./logo-text_aurus.svg": "d1d0",
	"./logo-text_sollers.svg": "e90f",
	"./logo_argo.svg": "f50b",
	"./logo_aurus.svg": "760b",
	"./logo_sollers.svg": "1d0b",
	"./mini-search.svg": "8976",
	"./notification.svg": "f3f4",
	"./orders.svg": "6973",
	"./person.svg": "9905",
	"./plus.svg": "5860",
	"./search.svg": "22ee",
	"./supplier.svg": "dba6",
	"./telephone.svg": "3aa5",
	"./timestamp.svg": "6062",
	"./toggler.svg": "3509",
	"./users.svg": "4e3e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";